'use client'
import { useUrlSync } from '@/app/[locale]/collection/hooks/use-url-sync'
import { useCollectionFilterStoreV2 } from '@/app/[locale]/collection/store/collection-filter-store-v2'
import type { TCollectionData } from '@/types/collection'
import { useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'

/**
 * Client component wrapper that handles filter state initialization and URL sync
 * Reused by all filter layouts (Standard, Carousel, SortOnly)
 */
export const CollectionFilterClient = ({
  serverData,
  initialFilters,
  children,
}: {
  serverData: TCollectionData
  initialFilters: Record<string, string | string[] | number | undefined>
  children: React.ReactNode
}) => {
  const { initialize } = useCollectionFilterStoreV2(
    useShallow((state) => ({ initialize: state.initialize }))
  )

  const { collection_detail } = serverData
  const { facets, card_facets } = collection_detail
  const originalSlug = collection_detail.seo_alias

  // Initialize store with facets data
  useEffect(() => {
    initialize(originalSlug, initialFilters, facets, card_facets)
  }, [initialize, originalSlug, initialFilters, facets, card_facets])

  // Sync URL to store
  useUrlSync(facets, card_facets)

  return <>{children}</>
}
